/**
 * <s-kiltra-catalog> — category filter buttons for the Kiltra catalog grid.
 *
 * Buttons carry data-filter (todos | collares | bandanas | comida); cards carry
 * data-cat. Links anywhere on the page to #catalogo-<filter> select that filter
 * and scroll the catalog into view. Each button carries data-bg; selecting it
 * paints that color on the surrounding catalog section, so the background
 * alternates between the two colors set in the block.
 */
class SKiltraCatalog extends HTMLElement {
  connectedCallback() {
    this.buttons = [...this.querySelectorAll('[data-filter]')];
    this.cards = [...this.querySelectorAll('[data-catalog-grid] > [data-cat]')];
    this.empty = this.querySelector('[data-catalog-empty]');
    this.controller = new AbortController();
    const { signal } = this.controller;

    this.buttons.forEach((button) => {
      button.addEventListener('click', () => this.apply(button.dataset.filter), { signal });
    });

    window.addEventListener('hashchange', () => this.fromHash(true), { signal });
    this.fromHash(false);
    const pressed = this.buttons.find((b) => b.getAttribute('aria-pressed') === 'true');
    if (pressed && !window.location.hash.startsWith('#catalogo-')) this.apply(pressed.dataset.filter);
  }

  disconnectedCallback() {
    this.controller?.abort();
  }

  fromHash(scroll) {
    const match = window.location.hash.match(/^#catalogo-(\w+)$/);
    if (!match) return;
    const filter = match[1];
    if (!this.buttons.some((b) => b.dataset.filter === filter)) return;
    this.apply(filter);
    if (scroll || document.readyState !== 'loading') {
      const target = this.closest('[id]') || this;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    }
  }

  apply(filter) {
    let visible = 0;
    this.buttons.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.filter === filter)));
    const active = this.buttons.find((b) => b.dataset.filter === filter);
    const region = this.closest('section') || this;
    if (active?.dataset.bg) region.style.backgroundColor = active.dataset.bg;
    this.cards.forEach((card) => {
      const show = filter === 'todos' || card.dataset.cat === filter;
      card.hidden = !show;
      if (show) visible += 1;
    });
    if (this.empty) this.empty.hidden = visible > 0;
    if (this.empty) this.empty.classList.toggle('hidden', visible > 0);
  }
}

if (!customElements.get('s-kiltra-catalog')) {
  customElements.define('s-kiltra-catalog', SKiltraCatalog);
}
